import { render, staticRenderFns } from "./CompanionHome.vue?vue&type=template&id=681e8275&lang=pug&"
import script from "./CompanionHome.vue?vue&type=script&lang=js&"
export * from "./CompanionHome.vue?vue&type=script&lang=js&"
import style0 from "./CompanionHome.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports